import { UserPermission } from '@synergy/models';

import { hasOneOf } from './has-one-of';

// TODO: Can be removed when user model is shared
interface UserWithPermissions {
    permissions?: UserPermission[];
}

export const hasPermission = (
    neededPermission: UserPermission | UserPermission[],
    user?: UserWithPermissions | null
) => {
    return hasOneOf(neededPermission, user?.permissions);
};
